import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 120 120" {...props}><path d="M60 95.5A35.54 35.54 0 0124.5 60 35.54 35.54 0 0160 24.5a35.53 35.53 0 0131.42 19h22.63A56.51 56.51 0 003.5 60a56.5 56.5 0 0097.72 38.62L85.88 84.25A35.37 35.37 0 0160.02 95.5z" /><path d="M120 0v45.34M91.42 43.5h22.62" fill="none" /><path d="M120 21.83l-.01 47.01-45.16-13.03z" /></svg>);